import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x50800000 {
  type: number;
  amount: number;
  id: number;
}

export function Command0x50800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    type: 0,
    amount: 0,
    id: 0,
  };

  const [fields, setFields] = React.useState<Form0x50800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x50800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.type) {
      params.type = 0;
    }
    if (!params.amount) {
      params.amount = 0;
    }
    if (!params.id) {
      params.id = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          // inputProps={{ min: 0 }}
          id="type"
          label="Тип платежа"
          margin="dense"
          fullWidth
          value={fields.type}
          onChange={handleChangeField("type")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          // inputProps={{ min: 0 }}
          id="amount"
          label="Сумма"
          margin="dense"
          fullWidth
          value={fields.amount}
          onChange={handleChangeField("amount")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          // inputProps={{ min: 0 }}
          id="id"
          label="ID платежа"
          margin="dense"
          fullWidth
          value={fields.id}
          onChange={handleChangeField("id")}
        />
      </FormControl>
    </>
  );
}
